import { render, staticRenderFns } from "./TestMonthlySummary.vue?vue&type=template&id=28615f32&"
import script from "./TestMonthlySummary.vue?vue&type=script&lang=js&"
export * from "./TestMonthlySummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports